module.exports = {"TXTWCL_Bet_Details":{"id":"TXTWCL_Bet_Details","defaultMessage":"Detalii pariu"}}